<div class="main-container" *ngIf="!isLoading" data-cy="patient-portal-confirm-appointment-main-container">

  <div class="main-title" data-cy="patient-portal-confirm-appointment-main-title-text">
    Your appointment is scheduled for: <br/>
    {{ appointment.displayTitle }}
  </div>

  <div class="sub-container" data-cy="patient-portal-confirm-appointment-arrival-time-container">
    <div class="sub-title" data-cy="patient-portal-confirm-appointment-arrival-time-title-text">
      Please select your arrival time
    </div>
    <mat-form-field class="time-select" data-cy="patient-portal-confirm-appointment-arrival-time-form-field">
      <mat-select [(ngModel)]="arrivalTime" data-cy="patient-portal-confirm-appointment-arrival-time-select-input">
        <mat-option *ngFor="let arriveTime of arriveTimes" [value]="arriveTime" data-cy="patient-portal-confirm-appointment-arrival-time-option">
          {{ arriveTime }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>

  <div class="action-container" data-cy="patient-portal-confirm-appointment-action-buttons-container">
    <button mat-button class="tdo-close" color="warn" (click)="close(false)" data-cy="patient-portal-confirm-appointment-cancel-action-button">Cancel</button>
    <button mat-raised-button class="tdo-save"color="primary" (click)="confirmAppointment()" [disabled]="!arrivalTime" data-cy="patient-portal-confirm-appointment-confirm-action-button">Confirm</button>
  </div>

</div>

<div *ngIf="isLoading" class="spinner-container" data-cy="patient-portal-confirm-appointment-loading-spinner">
  <mat-spinner data-cy="patient-portal-confirm-appointment-spinner"></mat-spinner>
</div>
